import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RegisteraddressPage } from './registeraddress';

@NgModule({
  declarations: [
    RegisteraddressPage,
  ],
  imports: [
    IonicPageModule.forChild(RegisteraddressPage),
  ],
})
export class RegisteraddressPageModule {}



// WEBPACK FOOTER //
// ./src/pages/registeraddress/registeraddress.module.ts